import { defineMessages } from '@jutro/locale';

export default defineMessages({
    customerChanges: {
        id: 'ml.gateway.views.ActivityReports.Customer Changes',
        defaultMessage: 'Customer Changes'
    },
    agentChanges: {
        id: 'ml.gateway.views.ActivityReports.Agent Changes',
        defaultMessage: 'Agent Changes'
    },
    policyChanges: {
        id: 'ml.gateway.views.ActivityReports.Policy Changes',
        defaultMessage: 'Policy Changes'
    },
    renewals: {
        id: 'ml.gateway.views.ActivityReports.Renewals',
        defaultMessage: 'Renewals'
    },
    claims: {
        id: 'ml.gateway.views.ActivityReports.Claims',
        defaultMessage: 'Claims'
    },
    billingAndCancels: {
        id: 'ml.gateway.views.ActivityReports.Billing & Cancels',
        defaultMessage: 'Billing & Cancels'
    },
    myFollowUps: {
        id: 'ml.gateway.views.ActivityReports.My Follow-ups',
        defaultMessage: 'My Follow-ups'
    },
    tasks: {
        id: 'ml.gateway.views.ActivityReports.Tasks',
        defaultMessage: 'Tasks'
    },
    cancellations: {
        id: 'ml.gateway.views.ActivityReports.Cancellations',
        defaultMessage: 'Cancellations'
    },
    incompletePended: {
        id: 'ml.gateway.views.ActivityReports.Incomplete/Pended Policies',
        defaultMessage: 'Incomplete/Pended Policies'
    },
    contingencies: {
        id: 'ml.gateway.views.ActivityReports.Contingencies',
        defaultMessage: 'Contingencies'
    },
    migrations: {
        id: 'ml.gateway.views.ActivityReports.Migrations',
        defaultMessage: 'Migrations'
    },
    quotes: {
        id: 'ml.gateway.views.ActivityReports.Quotes',
        defaultMessage: 'Quotes'
    },
    paymentLog: {
        id: 'ml.gateway.views.ActivityReports.Payment Log',
        defaultMessage: 'Payment Log'
    }
});
